<template>
  <div class="skeleton">
    <div class="skeleton-anime hidden lg:block px-6 py-2.5 font-bold rounded-xl text-base w-72 border-2 border-gray-200">
      <p class="opacity-0">
        button
      </p>
    </div>
  </div>
</template>
